import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// 요청 인터셉터
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 응답 인터셉터
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // 네트워크 에러 (서버 응답 없음)
    if (!error.response) {
      console.error('Network Error:', error);
      return Promise.reject(error);
    }

    const { status } = error.response;

    // 401 Unauthorized - 토큰 만료 또는 인증 실패
    if (status === 401) {
      const token = localStorage.getItem('accessToken');

      // 토큰이 있었다면 만료된 것이므로 삭제
      if (token) {
        console.log('토큰이 만료되었습니다. 토큰을 삭제합니다.');
        localStorage.removeItem('accessToken');

        // AuthContext가 상태를 업데이트하도록 페이지 새로고침
        window.location.reload();
      }
    }

    // 500 Internal Server Error
    if (status >= 500) {
      console.error('Server Error:', error);
    }

    return Promise.reject(error);
  },
);

export default apiClient;
